import React from 'react';

const Loader: React.FC = () => {
    return (
        <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
        </div>
    );
};

export default Loader; 